(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-navigation-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const labels = document.querySelector('[data-gm-navigation]');
    if (!labels) return;
    const drawers = [...document.querySelectorAll('#nt_menu_canvas,#nt_search_canvas,#nt_login_canvas,#nt_cart_canvas')];
    let active = null;
    let opener = null;
    const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const menuClose = () => document.querySelector('.close_mn_t4');
    const focusable = drawer => {
      const elements = [...drawer.querySelectorAll('a[href],button,input:not([type="hidden"]),select,textarea,[tabindex="0"]')].filter(element => !element.disabled && visible(element));
      if (drawer.id === 'nt_menu_canvas' && menuClose() && visible(menuClose())) elements.push(menuClose());
      return elements;
    };
    const synchronize = () => {
      document.querySelectorAll('.nt_fk_canvas .close_pp,.close_mn_t4').forEach(element => {
        element.setAttribute('role','button');
        element.setAttribute('tabindex','0');
        element.setAttribute('aria-label',labels.dataset.closeLabel);
      });
      document.querySelectorAll('#nt_search_canvas button[type="submit"]').forEach(element => element.setAttribute('aria-label',labels.dataset.searchLabel));
      document.querySelectorAll('#nt_menu_canvas .menu-item-has-children').forEach(item => {
        const link = item.querySelector(':scope > a');
        if (link) link.setAttribute('aria-expanded',String(item.classList.contains('nt_opended')));
      });
      const next = drawers.find(drawer => drawer.classList.contains('act_opened')) || null;
      document.querySelectorAll('.push_side[data-id]').forEach(trigger => {
        if (drawers.some(drawer => `#${drawer.id}` === trigger.dataset.id)) {
          trigger.setAttribute('aria-controls',trigger.dataset.id.slice(1));
          trigger.setAttribute('aria-expanded',String(Boolean(next && `#${next.id}` === trigger.dataset.id)));
        }
      });
      if (active !== next) {
        if (active) active.removeAttribute('aria-modal');
        active = next;
        if (active) {
          active.setAttribute('role','dialog');
          active.setAttribute('aria-modal','true');
          active.setAttribute('aria-label',opener?.getAttribute('aria-label') || opener?.textContent.trim() || active.querySelector('h3')?.textContent || labels.dataset.searchLabel);
          active.setAttribute('tabindex','-1');
          if (active.id === 'nt_menu_canvas' && menuClose()) {menuClose().id = 'gm-menu-close';active.setAttribute('aria-owns','gm-menu-close');}
          (active.querySelector('input:not([type="hidden"])') || focusable(active)[0] || active).focus({preventScroll:true});
        } else if (opener?.isConnected) opener.focus({preventScroll:true});
      } else if (active && document.activeElement === active && focusable(active).length) {
        (active.querySelector('input:not([type="hidden"])') || focusable(active)[0]).focus({preventScroll:true});
      }
    };
    document.addEventListener('click',event => {
      const trigger = event.target.closest('.push_side[data-id]');
      if (trigger && drawers.some(drawer => `#${drawer.id}` === trigger.dataset.id)) opener = trigger;
    },true);
    document.addEventListener('keydown',event => {
      if (!active) return;
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.close_pp')) {
        event.preventDefault(); event.target.click(); return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        (active.id === 'nt_menu_canvas' ? menuClose() : active.querySelector('.close_pp'))?.click();
        return;
      }
      if (event.key !== 'Tab') return;
      const elements = focusable(active), first = elements[0], last = elements.at(-1);
      if (!first) {event.preventDefault();active.focus();return;}
      if (event.shiftKey && (document.activeElement === first || !elements.includes(document.activeElement))) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && (document.activeElement === last || !elements.includes(document.activeElement))) {event.preventDefault();first.focus();}
    });
    const observer = new MutationObserver(synchronize);
    drawers.forEach(drawer => observer.observe(drawer,{attributes:true,attributeFilter:['class'],childList:true,subtree:true}));
    synchronize();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
